import { useSyncExternalStore } from 'react'

const RAIL_DRAWER_QUERY = '(max-width: 1199px)'
const mediaQuery =
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(RAIL_DRAWER_QUERY)
    : null

function subscribe(callback: () => void) {
  if (!mediaQuery) return () => {}
  mediaQuery.addEventListener('change', callback)
  return () => mediaQuery.removeEventListener('change', callback)
}

export function useIsRailDrawer() {
  return useSyncExternalStore(
    subscribe,
    () => mediaQuery?.matches ?? false,
    () => false,
  )
}
